// Drafts live in localStorage; this just keeps the UI reactive to them.
export const SET_GROUP_DRAFTS = "SET_GROUP_DRAFTS";

export const PUBLISH_GROUP_REQUEST = "PUBLISH_GROUP_REQUEST";
export const PUBLISH_GROUP_SUCCESS = "PUBLISH_GROUP_SUCCESS";
export const PUBLISH_GROUP_FAILURE = "PUBLISH_GROUP_FAILURE";

export const FETCH_GROUPS_REQUEST = "FETCH_GROUPS_REQUEST";
export const FETCH_GROUPS_SUCCESS = "FETCH_GROUPS_SUCCESS";
export const FETCH_GROUPS_FAILURE = "FETCH_GROUPS_FAILURE";
